import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing }) => {
	return {
		linkText: {
			paddingLeft: spacing(1),
			cursor: "pointer",
		},
		valueText: {
			paddingLeft: spacing(1),
		},
		shrinkable: {
			overflow: "hidden",
			textOverflow: "ellipsis",
		},
		inlineContainer: {
			display: "inline-flex",
			alignItems: "center",
		},
		iconContainer: {
			display: "flex",
			alignItems: "center",
			marginRight: spacing(0.5),
		},
		newTabLinkIcon: {
			fontSize: "16px",
			cursor: "pointer",
		},
		w600: {
			fontWeight: 600,
		},
		alignLeft: {
			textAlign: "left",
		},
		alignRight: {
			textAlign: "right",
		},
		alignCenter: {
			textAlign: "center",
		},
		table: {
			width: "100%",
			borderCollapse: "separate",
			borderSpacing: 0,
			"& th": {
				paddingRight: "16px",
				"@media(max-width: 1600px)": {
					paddingRight: "8px",
				},
			},
			"& th:nth-child(1)": {
				padding: 0,
			},
			tableLayout: "fixed",
		},
		tableBody: {
			"& tr:nth-child(1)": {
				"& td": {
					borderTop: "solid 1px #cddcdc",
				},
				"& td:nth-child(1)": {
					borderTopLeftRadius: "4px",
				},
				"& td:last-child": {
					borderTopRightRadius: "4px",
				},
			},
			"& tr:last-child": {
				"& td:nth-child(1)": {
					borderBottomLeftRadius: "4px",
				},
				"& td:last-child": {
					borderBottomRightRadius: "4px",
				},
			},
			"& td": {
				paddingRight: "16px",
				borderBottom: "solid 1px #cddcdc",
				"@media(max-width: 1600px)": {
					paddingRight: "8px",
				},
			},
			"& td:nth-child(1)": {
				padding: 0,
			},
		},
		cardRoot: {
			margin: "16px 3px",
			borderRadius: "4px",
		},
		refundGroupHeader: {
			display: "flex",
			padding: spacing(1, 3),
			justifyContent: "space-between",
			gap: spacing(2),
		},
		refundGroupHeaderLeft: {
			display: "flex",
			alignItems: "center",
			padding: spacing(1, 0),
			whiteSpace: "nowrap",
			overflow: "hidden",
		},
		refundGroupHeaderRight: {
			display: "flex",
			alignItems: "center",
			gap: spacing(1),
			flexShrink: 0,
		},
		reviewedTransactions: {
			display: "flex",
			alignItems: "center",
			gap: spacing(1),
			fontSize: "0.9rem",
			flexShrink: 0,
		},
		adjustedTransactions: {
			backgroundColor: "#f5f8f9",
			padding: "6px",
			borderRadius: "4px",
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			"& span": {
				lineHeight: 0,
			},
		},
	};
});
